import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ breakpoints, palette }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [breakpoints.between(0, 321)]: {
      flexFlow: 'column',
    },
  },
  sortCriteria: {
    '&>button, &>button:hover': {
      border: 0,
      outline: 0,
      boxShadow: 'none',
      color: palette.supporting.blue[300],
      fontSize: rem(16),
      paddingLeft: rem(4),
      paddingRight: rem(4),
    },
    '&>div>div[role=dialog]': {
      minWidth: rem(180),
    },
  },
  sortByCtn: {
    display: 'flex',
    alignItems: 'center',
  },
}));
